import { IUpdateDetailsStore } from '../pages/load-management/all-loads/upload-and-update/upload-and-update.interface';

export const initialUpdateDetailsState: IUpdateDetailsStore = {
  updateDetails: {
    proNumber: '',
    telephoneNo: '',
    sealNumber: '',
    trailerOrContainerNo: '',
    cabOrPowerNo: '',
    customsSealNumber: '',
    transportationMode: '',
    equipmentType: '',
    serviceType: '',
    serviceLevel: '',
    arrivalBegin: '',
    arrivalEnd: '',
    cutTime: '',
    departureBegin: '',
    departureEnd: '',
    loadType: '',
    driverName: ''
  },
  showUpdateDetailsPopup: false,
  isSubmitting: false,
  errors: {}
};
